<template>
  <div class="add-developer-modal">
    <v-dialog
      v-model="show"
      :max-width="currentComponentWidth"
      persistent
    >
      <v-card>
        <v-card-title
          class="add-developer-modal__title"
          primary-title
        >
          ADD NEW DEVELOPER
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-fade-transition mode="out-in">
            <component
              :is="currentComponent"
              :processing="isSubmitProcessing"
              @close="goBack"
              @select="selectFormType"
              @submit="submitForm"
            />
          </v-fade-transition>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AddDeveloperMenu from '@/components/Developers/AddDeveloperMenu.vue';
import InviteForm from '@/components/Developers/InviteForm.vue';
import JoinForm from '@/components/JoinForm.vue';

export default {
  components: {
    AddDeveloperMenu,
    InviteForm,
    JoinForm,
  },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      currentComponent: 'AddDeveloperMenu',
    };
  },

  computed: {
    ...mapState('hrDeveloper', [
      'isSubmitProcessing',
    ]),

    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    currentComponentWidth() {
      return this.currentComponent === 'AddDeveloperMenu' ? '780' : '560';
    },
  },

  methods: {
    ...mapActions('hrDeveloper', [
      'createDeveloper',
    ]),

    goBack() {
      this.currentComponent = 'AddDeveloperMenu';
    },

    closeModal() {
      this.$emit('input', false);
      this.currentComponent = 'AddDeveloperMenu';
    },

    clearSelection() {
      this.currentComponent = 'AddDeveloperMenu';
    },

    selectFormType(type) {
      this.currentComponent = type;
    },

    submitForm(newDeveloper) {
      this.createDeveloper(newDeveloper)
        .then((resp) => {
          this.$router.push({ name: 'hr-developer-show', params: { id: resp.data.personal_data.id } });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-developer-modal {
  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }
}
</style>
